import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = hashParams.get('session_id') || queryParams.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const data = await googleAuth(sessionId);
        const role = data.user?.role?.toLowerCase();
        if (role === 'admin') navigate('/admin');
        else if (role === 'lawyer') navigate('/lawyer');
        else if (role === 'agent') navigate('/agent');
        else navigate('/chat');
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login');
      }
    })();
  }, [googleAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-black border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-gray-500 font-mono">Authenticating...</p>
      </div>
    </div>
  );
}
